import styled from 'styled-components'

const Avatar = styled.img`
	width: 46px;
	height: 46px;
	border-radius: 50%;
`

export default Avatar
